/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverAdminDto } from '../models/DriverAdminDto';
import type { DriverAdminListedDtoAdmin } from '../models/DriverAdminListedDtoAdmin';
import type { DriverDriverDto } from '../models/DriverDriverDto';
import type { DriverOperatorDto } from '../models/DriverOperatorDto';
import type { DriverOrderSupportType } from '../models/DriverOrderSupportType';
import type { DriverStatus } from '../models/DriverStatus';
import type { DriverTrackingDetailAdminDto } from '../models/DriverTrackingDetailAdminDto';
import type { GetAvailableDriversAdminResponse } from '../models/GetAvailableDriversAdminResponse';
import type { GetDriverPerformanceAdminResponse } from '../models/GetDriverPerformanceAdminResponse';
import type { GetDriverPerformanceDriverResponse } from '../models/GetDriverPerformanceDriverResponse';
import type { GetDriversMonitoringResponseAdmin } from '../models/GetDriversMonitoringResponseAdmin';
import type { GetDriverStatusDriverResponse } from '../models/GetDriverStatusDriverResponse';
import type { GetDriverTimelineAdminResponse } from '../models/GetDriverTimelineAdminResponse';
import type { GetPhoneNumberCheckResponseAdmin } from '../models/GetPhoneNumberCheckResponseAdmin';
import type { Pagination1OfDriverAdminListedDto } from '../models/Pagination1OfDriverAdminListedDto';
import type { Pagination1OfDriverSessionAdminDto } from '../models/Pagination1OfDriverSessionAdminDto';
import type { Pagination1OfGetDriverSearchDriversAdminResponse } from '../models/Pagination1OfGetDriverSearchDriversAdminResponse';
import type { Pagination1OfGetSearchDriversAdminResponse } from '../models/Pagination1OfGetSearchDriversAdminResponse';
import type { PostDriverRequest } from '../models/PostDriverRequest';
import type { PostOfflineDriverResponse } from '../models/PostOfflineDriverResponse';
import type { PutDriverRequest } from '../models/PutDriverRequest';
import type { PutDriverStatusAdminResponse } from '../models/PutDriverStatusAdminResponse';
import type { PutDriverStatusRequestAdmin } from '../models/PutDriverStatusRequestAdmin';
import type { PutDriverTeamsAdminRequest } from '../models/PutDriverTeamsAdminRequest';
import type { PutLocationRequestDriver } from '../models/PutLocationRequestDriver';
import type { SearchDriverStatus } from '../models/SearchDriverStatus';
import type { VehicleTemplateType } from '../models/VehicleTemplateType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriversService {
    /**
     * @returns DriverOperatorDto OK
     * @throws ApiError
     */
    public static getDriverOperator({
        id,
    }: {
        id: number,
    }): CancelablePromise<DriverOperatorDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/drivers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns PostOfflineDriverResponse OK
     * @throws ApiError
     */
    public static postOfflineDriver({
        deviceId,
    }: {
        deviceId: string,
    }): CancelablePromise<PostOfflineDriverResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/drivers/offline',
            query: {
                'deviceId': deviceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns DriverDriverDto OK
     * @throws ApiError
     */
    public static getCurrentDriverDriver(): CancelablePromise<DriverDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/drivers/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverStatusDriverResponse OK
     * @throws ApiError
     */
    public static getDriverStatusDriver({
        deviceId,
    }: {
        deviceId: string,
    }): CancelablePromise<GetDriverStatusDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/drivers/current/status',
            query: {
                'deviceId': deviceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static putLocationDriver({
        requestBody,
    }: {
        requestBody?: PutLocationRequestDriver,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/driver/v1/drivers/location',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverPerformanceDriverResponse OK
     * @throws ApiError
     */
    public static getDriverPerformanceDriver({
        fromDate,
        toDate,
    }: {
        fromDate: string,
        toDate: string,
    }): CancelablePromise<GetDriverPerformanceDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/drivers/performance',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDrivers`
     * @returns DriverAdminDto Created
     * @throws ApiError
     */
    public static postDriverAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverRequest,
    }): CancelablePromise<DriverAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/drivers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDrivers`
     * @returns Pagination1OfDriverAdminListedDto OK
     * @throws ApiError
     */
    public static getDriversAdmin({
        id,
        userId,
        fullName,
        status,
        workingPhoneNumber,
        vehicleTemplateId,
        regionId,
        isBlocked,
        searchWord,
        createdAtFrom,
        createdAtTo,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        userId?: string,
        fullName?: string,
        status?: DriverStatus,
        workingPhoneNumber?: string,
        vehicleTemplateId?: number,
        regionId?: number,
        isBlocked?: boolean,
        searchWord?: string,
        createdAtFrom?: string,
        createdAtTo?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfDriverAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers',
            query: {
                'id': id,
                'userId': userId,
                'fullName': fullName,
                'status': status,
                'workingPhoneNumber': workingPhoneNumber,
                'vehicleTemplateId': vehicleTemplateId,
                'regionId': regionId,
                'isBlocked': isBlocked,
                'searchWord': searchWord,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverDetail`
     * @returns DriverAdminDto OK
     * @throws ApiError
     */
    public static getDriverAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<DriverAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDrivers`
     * @returns DriverAdminListedDtoAdmin OK
     * @throws ApiError
     */
    public static putDriverAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutDriverRequest,
    }): CancelablePromise<DriverAdminListedDtoAdmin> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/drivers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteDrivers`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteDriverAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/drivers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns DriverTrackingDetailAdminDto OK
     * @throws ApiError
     */
    public static getDriverTrackingDetailAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<DriverTrackingDetailAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/{id}/tracking-details',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetDriverTimelineAdminResponse OK
     * @throws ApiError
     */
    public static getDriverTimelineAdmin({
        id,
        fromDate,
        toDate,
        includeMovements,
    }: {
        id: number,
        fromDate: string,
        toDate: string,
        includeMovements?: boolean,
    }): CancelablePromise<GetDriverTimelineAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/{id}/timelines',
            path: {
                'id': id,
            },
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'includeMovements': includeMovements,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverSessions`
     * @returns Pagination1OfDriverSessionAdminDto OK
     * @throws ApiError
     */
    public static getDriverSessionsAdmin({
        id,
        fromDate,
        toDate,
        page,
        limit,
    }: {
        id: number,
        fromDate: string,
        toDate: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverSessionAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/{id}/sessions',
            path: {
                'id': id,
            },
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDrivers`
     * @returns GetPhoneNumberCheckResponseAdmin OK
     * @throws ApiError
     */
    public static getPhoneNumberCheckAdmin({
        phoneNumber,
    }: {
        phoneNumber: string,
    }): CancelablePromise<GetPhoneNumberCheckResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/phone-number-check',
            query: {
                'phoneNumber': phoneNumber,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetDriversMonitoringResponseAdmin OK
     * @throws ApiError
     */
    public static getDriversMonitoringAdmin({
        regionIds,
        driverStatuses,
        driverOrderSupportTypes,
    }: {
        regionIds: Array<number>,
        driverStatuses: Array<DriverStatus>,
        driverOrderSupportTypes?: Array<DriverOrderSupportType>,
    }): CancelablePromise<GetDriversMonitoringResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/monitoring',
            query: {
                'regionIds': regionIds,
                'driverStatuses': driverStatuses,
                'driverOrderSupportTypes': driverOrderSupportTypes,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewAvailableDrivers`
     * @returns GetAvailableDriversAdminResponse OK
     * @throws ApiError
     */
    public static getAvailableDriversAdmin({
        id,
        userId,
        fullName,
        workingPhoneNumber,
        vehicleTemplateId,
        driverTeamId,
        vehicleTemplateType,
        orderSupportType,
        canHandleSensitiveOrders,
        regionIds,
    }: {
        id?: number,
        userId?: string,
        fullName?: string,
        workingPhoneNumber?: string,
        vehicleTemplateId?: number,
        driverTeamId?: number,
        vehicleTemplateType?: VehicleTemplateType,
        orderSupportType?: DriverOrderSupportType,
        canHandleSensitiveOrders?: boolean,
        regionIds?: Array<number>,
    }): CancelablePromise<GetAvailableDriversAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/available',
            query: {
                'id': id,
                'userId': userId,
                'fullName': fullName,
                'workingPhoneNumber': workingPhoneNumber,
                'vehicleTemplateId': vehicleTemplateId,
                'driverTeamId': driverTeamId,
                'vehicleTemplateType': vehicleTemplateType,
                'orderSupportType': orderSupportType,
                'canHandleSensitiveOrders': canHandleSensitiveOrders,
                'regionIds': regionIds,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDrivers`
     * @returns PutDriverStatusAdminResponse OK
     * @throws ApiError
     */
    public static putDriverStatusAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutDriverStatusRequestAdmin,
    }): CancelablePromise<PutDriverStatusAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/drivers/{id}/status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDrivers`
     * @returns any OK
     * @throws ApiError
     */
    public static putDriverTeamsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutDriverTeamsAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/drivers/{id}/teams',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverPerformance`
     * @returns GetDriverPerformanceAdminResponse OK
     * @throws ApiError
     */
    public static getDriverPerformanceAdmin({
        id,
        fromDate,
        toDate,
    }: {
        id: number,
        fromDate: string,
        toDate: string,
    }): CancelablePromise<GetDriverPerformanceAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/{id}/performance',
            path: {
                'id': id,
            },
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDrivers`
     * @returns Pagination1OfGetSearchDriversAdminResponse OK
     * @throws ApiError
     */
    public static getSearchDriversAdminAsyncAdmin({
        searchWord,
        from,
        to,
        driverId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        from?: string,
        to?: string,
        driverId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfGetSearchDriversAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/search-drivers',
            query: {
                'searchWord': searchWord,
                'from': from,
                'to': to,
                'driverId': driverId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDrivers`
     * @returns Pagination1OfGetDriverSearchDriversAdminResponse OK
     * @throws ApiError
     */
    public static getDriverSearchDriversAdmin({
        id,
        searchWord,
        from,
        to,
        statuses,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id: number,
        searchWord?: string,
        from?: string,
        to?: string,
        statuses?: Array<SearchDriverStatus>,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfGetDriverSearchDriversAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivers/{id}/search-drivers',
            path: {
                'id': id,
            },
            query: {
                'searchWord': searchWord,
                'from': from,
                'to': to,
                'statuses': statuses,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
